module.exports = __webpack_public_path__ + "static/media/11-normal.5856b8ad.png";